(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
(() => {
  function setup(root) {
    root.querySelectorAll('[data-galea-filter-groups]').forEach(panel => {
      if (panel.dataset.galeaReady) return;
      panel.dataset.galeaReady = 'true';
      const sync = () => {
        panel.querySelectorAll('.GaleaFilterGroups__group').forEach(group => {
          let label = '';
          group.querySelectorAll('[data-action="toggle-tag"]').forEach(button => {
            const active = button.classList.contains('is-active');
            button.setAttribute('aria-pressed', String(active));
            if (active) label = button.textContent.trim();
          });
          const selection = group.querySelector('[data-galea-filter-selection]');
          if (selection.textContent !== label) selection.textContent = label;
        });
      };
      sync();
      new MutationObserver(sync).observe(panel, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-with-sub"]) return;
  try {
    

	console.log('pop');	
	var Contenedor1=(jQuery('body').find('.parallax1').length != 0)?jQuery('body').find('parallax1'):'';
	var Contenedor2=(jQuery('body').find('.parallax2').length != 0)?jQuery('body').find('parallax2'):'';  

	var per1=20;
	var per2=10;

  
  jQuery(window).scroll(function(event) {
      var w=window.innerWidth;
      var h=window.innerHeight;

      jQuery('body').find('.parallax1').each(function(){
        var pos=jQuery(this).offset().top;
        var scrolled = jQuery(window).scrollTop();
        var mov=(pos>h)?scrolled-pos+h:scrolled; 
          if(scrolled +h+500  > pos){
  			jQuery(this).css({'transform':'translate3d(0,'+mov*(-per1/100)+'px,0)'});
          } 
      });   
   
      jQuery('body').find('.parallax2').each(function(){
        var pos=jQuery(this).offset().top;
        var scrolled = jQuery(window).scrollTop();
        var mov=(pos>h)?scrolled-pos+h:scrolled; 
          if(scrolled +h+500  > pos){
           jQuery(this).css({'transform':'translate3d(0,'+(mov)*(-per2/100)+'px,0)'});
          } 
      });
  
      jQuery('.hide').each(function(){
  			  var sc = jQuery(window).scrollTop();
              var pos=jQuery(this).offset().top;
              if( sc >= pos - h + 250 ) {
               jQuery(this).removeClass('hide').addClass('see');
              }
      });
  });
     
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    


var Contenedor1=(jQuery('body').find('.parallax1').length != 0)?jQuery('body').find('parallax1'):'';
var Contenedor2=(jQuery('body').find('.parallax2').length != 0)?jQuery('body').find('parallax2'):'';  

var per1=20;
var per2=10;


jQuery(window).scroll(function(event) {
var w=window.innerWidth;
var h=window.innerHeight;

jQuery('body').find('.parallax1').each(function(){
var pos=jQuery(this).offset().top;
var scrolled = jQuery(window).scrollTop();
var mov=(pos>h)?scrolled-pos+h:scrolled; 
if(scrolled +h+500  > pos){
jQuery(this).css({'transform':'translate3d(0,'+mov*(-per1/100)+'px,0)'});
} 
});   

jQuery('body').find('.parallax2').each(function(){
var pos=jQuery(this).offset().top;
var scrolled = jQuery(window).scrollTop();
var mov=(pos>h)?scrolled-pos+h:scrolled; 
if(scrolled +h+500  > pos){
jQuery(this).css({'transform':'translate3d(0,'+(mov)*(-per2/100)+'px,0)'});
} 
});

jQuery('.hide-ll').each(function(){
var sc = jQuery(window).scrollTop();
var pos=jQuery(this).offset().top;
if( sc >= pos - h + 250 ) {
jQuery(this).removeClass('hide-ll').addClass('see');
}
});
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-portada"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('galea-collection-carousel')) {
  customElements.define('galea-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.autoplayTimer);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.galea-carousel__track');
      this.slides = [...this.querySelectorAll('.galea-carousel__slide')];
      const controls = this.querySelector('.galea-carousel__controls');
      controls.hidden = this.slides.length < 2;
      controls.replaceChildren();
      this.dots = this.slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Ver imagen ' + (index + 1));
        button.addEventListener('click', () => this.show(index), options);
        controls.append(button);
        return button;
      });
      this.index = 0;
      const update = () => {
        const width = this.track.clientWidth;
        this.index = width ? Math.round(this.track.scrollLeft / width) : 0;
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      };
      this.track.addEventListener('scroll', update, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) this.show(index);
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const index = (this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length;
        this.show(index);
        this.slides[index].focus({ preventScroll: true });
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.track.scrollTo({left: this.index * this.track.clientWidth, behavior:'instant'}));
      this.resizeObserver.observe(this.track);
      update();
      const interval = Number(this.dataset.interval) || 5000;
      this.lastInteraction = 0;
      this.addEventListener('pointerdown', () => { this.lastInteraction = Date.now(); }, options);
      this.autoplayTimer = setInterval(() => {
        if (this.slides.length < 2 || document.hidden || window.Shopify?.designMode ||
            matchMedia('(prefers-reduced-motion: reduce)').matches ||
            Date.now() - this.lastInteraction < interval) return;
        this.show((this.index + 1) % this.slides.length);
      }, interval);
    }
    show(index) {
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); clearInterval(this.autoplayTimer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galea-campeggi-product"]) return;
  try {
    
(() => {
  const states = new WeakMap();
  const selectedValues = picker => Array.from(picker.querySelectorAll('[data-campeggi-option]')).map(group => {
    const control = group.querySelector('select') || group.querySelector('input[type="radio"]:checked');
    return control ? control.value : null;
  });
  const stateFor = section => {
    if (!states.has(section)) {
      const picker = section.querySelector('[data-campeggi-options]');
      const button = section.querySelector('.GaleaCampeggiProduct__Form button[type="submit"]');
      if (!picker || !button) return null;
      states.set(section, {request: 0, controller: null, pending: false, confirmedOptions: picker.cloneNode(true), buttonDisabled: button.disabled});
    }
    return states.get(section);
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-campeggi-product]').forEach(stateFor);
  };
  const focusReplacement = (section, id) => {
    if (!id) return;
    const replacement = document.getElementById(id);
    if (replacement && section.contains(replacement)) replacement.focus({preventScroll: true});
  };
  const setBusy = (section, busy) => {
    ['[data-campeggi-options]', '.GaleaCampeggiProduct__Form'].forEach(selector => {
      const element = section.querySelector(selector);
      if (busy) element?.setAttribute('aria-busy', 'true');
      else element?.removeAttribute('aria-busy');
    });
  };
  document.addEventListener('change', async event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const picker = target.closest('[data-campeggi-options]');
    const section = picker?.closest('[data-campeggi-product]');
    if (!section) return;
    const values = selectedValues(picker);
    if (!values.length || values.some(value => !value)) return;
    const state = stateFor(section);
    if (!state) return;
    const current = ++state.request;
    state.controller?.abort();
    const controller = new AbortController();
    state.controller = controller;
    state.pending = true;
    const form = section.querySelector('.GaleaCampeggiProduct__Form');
    const button = form.querySelector('button[type="submit"]');
    const error = section.querySelector('[data-campeggi-error]');
    if (error) error.hidden = true;
    button.disabled = true;
    setBusy(section, true);
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.set('option_values', values.join(','));
    pageUrl.searchParams.delete('variant');
    const requestUrl = new URL(pageUrl);
    requestUrl.searchParams.set('section_id', section.dataset.sectionId);
    let timedOut = false;
    const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 20000);
    try {
      const response = await fetch(requestUrl.toString(), {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw new Error('Section request failed');
      const responseText = await response.text();
      if (current !== state.request || !section.isConnected) return;
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const nextSection = html.querySelector('[data-campeggi-product]');
      if (!nextSection || nextSection.dataset.productId !== section.dataset.productId || nextSection.dataset.sectionId !== section.dataset.sectionId) throw new Error('Unexpected product section');
      const nextOptions = nextSection.querySelector('[data-campeggi-options]');
      const nextPrice = nextSection.querySelector('.GaleaCampeggiProduct__Price');
      const nextForm = nextSection.querySelector('.GaleaCampeggiProduct__Form');
      const nextVariantInput = nextForm?.querySelector('input[name="id"]');
      const nextButton = nextForm?.querySelector('button[type="submit"]');
      const nextVariantData = nextSection.querySelector('[data-campeggi-variant]');
      if (!nextOptions || !nextPrice || !nextVariantInput || !nextButton || !nextVariantData || selectedValues(nextOptions).join(',') !== values.join(',')) throw new Error('Incomplete product configuration');
      const variant = JSON.parse(nextVariantData.textContent);
      if (variant ? String(variant.id) !== nextVariantInput.value : nextVariantInput.value !== '' || !nextButton.disabled) throw new Error('Inconsistent product configuration');
      const focusedId = picker.contains(document.activeElement) ? document.activeElement.id : null;
      picker.replaceWith(nextOptions);
      section.querySelector('.GaleaCampeggiProduct__Price').replaceChildren(...nextPrice.childNodes);
      form.querySelector('input[name="id"]').value = nextVariantInput.value;
      button.replaceChildren(...nextButton.childNodes);
      button.disabled = nextButton.disabled;
      section.querySelector('[data-campeggi-variant]').textContent = nextVariantData.textContent;
      state.confirmedOptions = nextOptions.cloneNode(true);
      state.buttonDisabled = button.disabled;
      state.pending = false;
      setBusy(section, false);
      try { window.history.replaceState(window.history.state, '', pageUrl.toString()); } catch (_) {}
      focusReplacement(section, focusedId);
      section.dispatchEvent(new CustomEvent('variant:changed', {bubbles: true, detail: {variant}}));
    } catch (failure) {
      if (current !== state.request || !section.isConnected || (failure.name === 'AbortError' && !timedOut)) return;
      const currentPicker = section.querySelector('[data-campeggi-options]');
      const focusedId = currentPicker?.contains(document.activeElement) ? document.activeElement.id : null;
      currentPicker?.replaceWith(state.confirmedOptions.cloneNode(true));
      button.disabled = state.buttonDisabled;
      if (error) {
        const recovery = error.querySelector('[data-campeggi-recovery]');
        if (recovery) recovery.href = pageUrl.toString();
        error.hidden = false;
      }
      focusReplacement(section, focusedId);
    } finally {
      clearTimeout(timer);
      if (current === state.request) {
        state.pending = false;
        state.controller = null;
        setBusy(section, false);
      }
    }
  });
  document.addEventListener('submit', event => {
    const section = event.target.closest?.('[data-campeggi-product]');
    if (section && states.get(section)?.pending) event.preventDefault();
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll?.('[data-campeggi-product]').forEach(section => {
      const state = states.get(section);
      if (!state) return;
      ++state.request;
      state.controller?.abort();
      states.delete(section);
    });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
})();

  } catch(e) { console.error(e); }
})();
})();
